export type State = {
  // key: *store.asyncActions.*.typePrefix
  // value: pending or not
  [key: string]: boolean;
};

const initialState: State = {};

const reducer = (state = initialState, action: any) => {
  const { type } = action;
  const matches = /(.*)\/(pending|fulfilled|rejected)/.exec(type);

  if (!matches) {
    return state;
  }

  // requestName: *store.asyncActions.*.typePrefix
  // requestState: pending | fulfilled | rejected
  const [, requestName, requestState] = matches;

  return {
    ...state,
    [requestName]: requestState === 'pending',
  };
};

export default reducer;
